<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Notifications</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">
        Dashboard
      </router-link>
      /

      <b>Notifications</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <button class="btn btn-primary" @click="markAllRead" v-if="notifications.length !== 0">
      Mark All As Read
    </button>

    <br />
    <br />

    <div class="card" v-for="(noti, i) in notifications" :key="i" style="margin-bottom: 1em">
      <div v-if="noti.data.claim_id">
        <router-link :to="`/tba/claim_details/${noti.data.claim_id}`">
          <div class="card-body">
            <div class="card-text">
              <span @click="markAsRead(noti)" class="pointer">
                <b class="text-primary">
                  {{ noti.data.message }}
                </b>
              </span>
            </div>
            <small>
              <i>{{ noti.created_at | moment("Do MMMM YYYY, h:mm:ss a") }}</i>
            </small>
          </div>
        </router-link>
      </div>
      <div v-else>
        <div class="card-body">
          <div class="card-text">
            <span @click="markAsRead(noti)" class="pointer">
              <b class="text-primary">
                {{ noti.data.message }}
              </b>
            </span>
          </div>
          <small>
            <i>{{ noti.created_at | moment("Do MMMM YYYY, h:mm:ss a") }}</i>
          </small>
        </div>
      </div>


    </div>
  </div>
</template>

<script>
import axios from "axios";
const user = JSON.parse(localStorage.getItem("user"));

export default {
  name: "notifications",

  data() {
    return {
      notifications: "",
      checkNoti: []
    };
  },

  methods: {
    getNotification() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/notifications/unreads", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.notifications = res.data;
          });
      }
    },

    notificationLink(noti) {
      if (
        noti.data.tb_type === "tba" &&
        noti.data.notification_type === "purchase"
      ) {
        return "tba_purchase";
      } else if (
        noti.data.tb_type === "tba" &&
        noti.data.notification_type === "call"
      ) {
        return "tba_call_request";
      } else if (
        noti.data.tb_type === "tbk" &&
        noti.data.notification_type === "call"
      ) {
        return "tbk_call_request";
      } else if (
        noti.data.notification_type === "product_approval_notification"
      ) {
        if (user.roles[0].name == "Marketing") {
          return "/vendor/product/" + noti.data.vendor_id;
        }
        return "/products-services/";
      } else if (
        noti.data.notification_type === "vendor_product_notification "
      ) {
        return "/vendor/product/" + noti.data.vendor_id;
      } else if (noti.data.notification_type === "vendor_banner_notification") {
        if (user.roles[0].name == "Marketing") {
          return "/vendor/company/" + noti.data.vendor_id;
        }
        return "/banner";
      } else if (
        noti.data.notification_type === "invoice_upload_notification"
      ) {
        if (user.roles[0].name == "Marketing") {
          return "/report/update/" + noti.data.entity_id;
        }
        return (
          "/payout/view/" +
          noti.data.entity_id +
          "/" +
          noti.data.month +
          "/" +
          noti.data.year
        );
      }
    },

    markAsRead(noti) {
      let token = localStorage.getItem("token");

      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/notifications/mark_as_read/" + noti.id,
            {},
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            // this.getNotification()
            this.$router.push(this.notificationLink(noti));
          });
      }
    },

    markAllRead() {
      let token = localStorage.getItem("token");

      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .post(
            "/notifications/mark_all_as_read",
            {},
            {
              headers: {
                Authorization: "Bearer " + token
              }
            }
          )
          .then(res => {
            this.getNotification();
            // this.$router.push(this.notificationLink(noti))
            // windows.location.reloasd()
          });
      }
    }
  },

  mounted() {
    this.getNotification();
  }
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}
</style>
